<template>
  <div class="categories-main-container">
    <div>
      <span class="multiple-categories-container">
        <figure v-for="(category,index) in filteredCategories" class="categories-container" :data-balloon="category.name" data-balloon-pos="up-left" :key="index">
          <img v-if="category.image !== ''" :src="category.image" alt="Category Image">
        </figure>
      </span>
    </div>
    <div class="right-icon">
      <figure v-if="isSpamReviewPending" class="categories-container" :data-balloon="getTooltipText()" data-balloon-pos="up-right">
        <i style="color: whitesmoke;" class="fa-regular fa-flag review-pending"></i>
      </figure>
      <figure v-if="isSpamDetected" class="categories-container" :data-balloon="getTooltipText()" data-balloon-pos="up-right">
        <i style="color: whitesmoke;" class="fa-regular fa-2x fa-ban marked-spam"></i>
      </figure>
    </div>
  </div>
</template>

<script>
import projectStatuses from '@/mixins/project-statuses'
export default {
  props: ['categories', 'status'],
  mixins: [projectStatuses],
  computed: {
    filteredCategories: function () {
      return this.categories ? this.categories.slice(0, 9) : []
    },
    projectStatus: function () {
      return this.status ? this.checkProjectStatus(this.status) : ''
    },
    isSpamDetected: function () {
      return this.projectStatus === 'spamDetected'
    },
    isSpamReviewPending: function () {
      return this.projectStatus === 'pendingSpamCheck'
    }
  },
  methods: {
    getTooltipText: function () {
      if (this.isSpamDetected) {
        return 'Marked Spam'
      } else if (this.isSpamReviewPending) {
        return 'Pending Review'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '~styles/utils.scss';
  .categories-main-container {
    width: 100%;
    margin: 0.25rem;
    display: flex;
    min-height: 1.5rem;
    @include touch {
      padding-left: 0.5rem;
    }
    span {
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
  .categories-container {
    width: 1.5rem;
    height: 1.5rem;
    display: inline-block;
    z-index: 4;
    overflow: visible;
    @include mobile {
      width: 2rem;
      height: 2rem;
    }
    img {
      display: block;
      width: 100%;
      height: 100%;
      border-radius: 50%;
    }
  }
  .multiple-categories-container {
    .categories-container{
      position: relative;
    }
  }
  .right-icon {
    width: 100%;
    margin: 0.25rem;
    display: flex;
    min-height: 1.3rem;
    justify-content: right;
    span {
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }

  .review-pending {
    display: inline-block;
    border-radius: 50px;
    box-shadow: 0 0 2px;
    padding: 0.3em 0.4em;
    background-color: darkorange;
    color: whitesmoke;
  }
  .marked-spam {
    border-radius: 50px;
    background-color: red;
    color: whitesmoke;
  }
</style>
